import 'aframe'

console.log('test')

